<template>
    <div class="bg-[#252526] z-30 rounded-[10px] p-3 absolute">
        <div v-if="loader" class="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-gray-300 w-[450px] h-[480px] opacity-25 z-60"></div>
        <div v-if="loader" class="w-5 h-5 rounded-full animate-spin border-solid border-4 border-[#DA4167] border-t-transparent absolute top-[50%] left-[50%] -mt-5 -ml-[10px] z-50"></div>
		<cropper
            class="-z-30 cropper-styles"
			ref="cropper"
			:src="image.src"
		/>
        <button 
            class="px-2 py-1 bg-[#DA4167] hover:bg-[#bf2c5f] text-white text-xs rounded-md w-full"
            @click="crop"
        >Зберегти</button>
	</div>
</template>

<script>
    import { ref } from 'vue'
    import { sendPhotoToRemoveBg } from '../../services/apiRequests'

    import { Cropper } from 'vue-advanced-cropper'
    import 'vue-advanced-cropper/dist/style.css'

    export default {

        props: {
            image: {
                type: Object,
                default: () => ({})
            },

            height: {
                type: String,
                default: '200px'
            },

            width: {
                type: String,
                default: '226px'
            }
        },

        setup(props, { emit }) {
            const cropper = ref(null)
            const loader = ref(false)

            const crop = () =>{
                loader.value = true
                const { canvas } = cropper.value.getResult();
                canvas.toBlob((blob) => {
                    sendPhotoToRemoveBg(blob).then(res => {
                        const blob_file = new Blob([res], {type: "image/png"})
                        
                        var reader = new FileReader()
                        reader.readAsDataURL(blob_file)
                        
                        reader.onloadend = () => {  
                            emit('processedImage', reader.result)
                            loader.value = false
                        }
                    })
                }, props.image.type);
            }

            return {
                crop,
                cropper,
                loader
            }
        },

        components: {
            Cropper,
        },

    }
</script>

<style lang="scss" scoped>

    .cropper-styles {
        height: v-bind(height);
        width: v-bind(width);
    }

</style>